import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export type RollDefinitionResponse = {
  name: string;
  description: string;
  definition: string;
};

@Injectable({ providedIn: 'root' })
export class RollDefinitionService {
  private http = inject(HttpClient);

  async fetchForCharacter(
    storyId: number,
    characterId: number,
    name: string,
    description: string,
  ): Promise<RollDefinitionResponse> {
    const base = environment.masterServerUrl?.replace(/\/+$/, '') ?? '';
    const url = `${base}/api/${storyId}/roll-definition`;
    return firstValueFrom(
      this.http.post<RollDefinitionResponse>(url, {
        characterId,
        name,
        description,
      }),
    );
  }
}
